import React from 'react'
import "./Pagination.scss"
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

function Pagination({ hasNextPage, hasPreviousPage, handleNext, handlePrevious, currentPage, totalPageCount }) {
  return (
    <div className="pagination">
      <div>
        <button className="pagination-button" disabled={!hasPreviousPage} onClick={handlePrevious} >
          <LeftOutlined />
        </button>
        <span className="pagination-span">{currentPage ? currentPage : 0} - {totalPageCount ? totalPageCount : 0}</span>
        <button className="pagination-button" disabled={!hasNextPage} onClick={handleNext} >
          <RightOutlined />
        </button>
      </div>
    </div>
  )
}

export default Pagination;